import { render } from "./LandingDemo.vue?vue&type=template&id=43430a3b"
import script from "./LandingDemo.vue?vue&type=script&lang=js"
export * from "./LandingDemo.vue?vue&type=script&lang=js"

import "./LandingDemo.vue?vue&type=style&index=0&id=43430a3b&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__